import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useMedplumContext } from "@medplum/react-hooks";
import { motion } from "framer-motion";

import { ROUTES } from "@/constants/routes.constants";
import { medplumClient } from "@/lib/medplum";
import { logoLayoutTransition } from "@/lib/utils";
import { useLoginProcessing } from "@/context/login-provider";

import { Logo } from "@/components/base/Logo";

import { LanguageSwitcher } from "./LanguageSwitcher";

export const GuestRoute: React.FC = () => {
  const { loading } = useMedplumContext();
  const { isLoginProcessing } = useLoginProcessing();
  const navigate = useNavigate();

  const isAuthenticated =
    !loading && !isLoginProcessing && medplumClient.isAuthenticated();

  /**
   * useEffect is used instead of <Navigate> because <Navigate> does not support
   * the viewTransition prop — it only accepts to/replace/state/relative. By
   * keeping <Outlet /> rendered while the effect fires, the browser captures
   * the Login page as the "old" state for the cross-fade transition.
   */
  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.HOME, { replace: true, viewTransition: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="flex min-h-screen flex-col">
      <header className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <motion.div layoutId="app-logo" transition={logoLayoutTransition}>
            <Logo className="h-10" />
          </motion.div>
        </div>
        <LanguageSwitcher />
      </header>
      <div className="flex flex-1 items-center justify-center">
        <Outlet />
      </div>
    </div>
  );
};
